import { IUserInteractiveComponent } from '@adaptiva/core/common';
import { LogicalCondition } from '@adaptiva/core/filters';
import { UiService } from '@adaptiva/core/ui';
import { BaseWidgetComponent, WidgetService } from '@adaptiva/core/widgets';
import { DeletedObjectsFilterService } from '@adaptiva/metadata/common';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
	standalone: false,
	selector: 'ada-deleted-object-toggle',
	templateUrl: './deleted-object-toggle.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeletedObjectToggleComponent extends BaseWidgetComponent implements IUserInteractiveComponent<boolean> {

	public deletedObjectMargin: string = JSON.stringify([
		this.ui.Spacing.SPACING_NONE,
		this.ui.Spacing.SPACING_MEDIUM,
		this.ui.Spacing.SPACING_NONE,
		this.ui.Spacing.SPACING_NONE
	]);

	public isToggled: boolean = false;

	public get value(): boolean {
		return this.isToggled;
	}

	@Output()
	public isToggledChange: EventEmitter<boolean> = new EventEmitter();

	@Output()
	public staticFilterConditionChange: EventEmitter<LogicalCondition> = new EventEmitter();

	@ViewChild(ToggleSwitchComponent)
	public toggleSwitch: ToggleSwitchComponent;

	constructor(
		public ui: UiService,
		private _deletedObjectsFilterSerivce: DeletedObjectsFilterService,
		_widgetService: WidgetService,
	) {
		super(_widgetService);
	}

	protected emitStaticFilterCondition(): void {
		const _staticFilterCondition: LogicalCondition = this.generateStaticFilterCondition();

		this.staticFilterConditionChange.emit(_staticFilterCondition);
	}

	protected generateStaticFilterCondition(): LogicalCondition {
		if (this.isToggled)
			return this._deletedObjectsFilterSerivce.getShowDeletedFilter();

		return this._deletedObjectsFilterSerivce.getHideDeletedFilter();
	}

	public setValue(_value: boolean, _emit: boolean): void {
		this.toggleSwitch.isToggled.set(_value);
		this.isToggled = _value;
		if (!_emit)
			return;

		this.isToggledChange.emit(_value);
		this.emitStaticFilterCondition();
	}

	public toggleStaticFilter(_isToggled: boolean): void {
		this.isToggled = _isToggled;
		this.emitStaticFilterCondition();
		this.isToggledChange.emit(_isToggled);
	}

}
